import { createStyles, withStyles, WithStyles } from "@material-ui/core";
import { Button } from "bc-front-sagacomponents";
import React, { Component } from "react";
import Layout from "../Layout";

interface IProps extends WithStyles<typeof styles> {
  onRetry?(): void;
}

interface IState {
  error: any;
  errorInfo: any;
}

const styles = createStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    marginTop: 24,
  },
  button: {
    marginTop: 30,
  },
  message: {
    marginBottom: 16,
  },
});

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  handleRetry = () => {
    if (this.props.onRetry) {
      this.props.onRetry();
      this.setState({
        error: null,
        errorInfo: null,
      });
    } else {
      window.location.reload();
    }
  };
  render() {
    const { children } = this.props;
    if (this.state.errorInfo) {
      // Error path
      return (
        <Layout>
          <div style={{ padding: 24 }}>
            <h2>Une erreur est survenue</h2>
            <details style={{ whiteSpace: "pre-wrap" }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>{" "}
            <Button
              title="Réessayer"
              variant="contained"
              color="primary"
              onClick={this.handleRetry}
            />
          </div>
        </Layout>
      );
    }
    // Normally, just render children
    return children;
  }
}

export default withStyles(styles)(ErrorBoundary);
